import Vue from 'vue';
import Tab from '../general/tab';
import StockManager from './stock/stockmanager';
import axios from 'axios';
import qs from 'qs';

export default Vue.component('inventorytab', {
    template:`
    <div v-bind:id="id" class="tab-pane" v-bind:class="[{ active: isActive }, panelCssClass]">
        <div class="tab-pane--loader text-center" v-show="loading">
            <i class="si si-settings fa-3x fa-spin spinner"></i>
        </div>
        <div v-show="!loading">
            <stockmanager v-bind="{ collectionResourcesWastes: collectionResourcesWastes, pieceCollectionResourcesWastes: pieceCollectionResourcesWastes, collectionResourcesStock: collectionResourcesStock, pieceCollectionResourcesStock: pieceCollectionResourcesStock, permissions: permissions, sentences: sentences }"></stockmanager>
        </div>
    </div>
    `,
    extends: Tab,
    components: {
        ResourceManager: 'resourcemanager',
        StockManager: 'stockmanager'
    },
    data: function(){
        return {
            axe: axios.create({
                baseURL: '/webapi/servicepointstock',
                paramsSerializer: function(params) {
                    return qs.stringify(params, { indices: false, allowDots: true, skipNulls: true })
                }
            }),
            loading: true,
            servicePointId: '',
            collectionResourcesWastes: { 
                selected: [],
                unselected: []
            },
            pieceCollectionResourcesWastes:  { 
                selected: [],
                unselected: [] 
            },
            collectionResourcesStock: [],
            pieceCollectionResourcesStock: [],
            permissions: {
                canEdit: false
            },
            sentences:{ }
        }
    },
    methods:{
        saveTab(){
            this.axe.put('/savestock', {
                servicePointId: this.servicePointId,
                selectedResources: this.collectionResourcesWastes.selected,
                selectedPieceCollections: this.pieceCollectionResourcesWastes.selected,
                resourcesStock: this.collectionResourcesStock,
                pieceCollectionResourcesStock: this.pieceCollectionResourcesStock
            })
            .then((response) => {
                One.helpers('notify', { ...response.data.notification, message: response.data.notification.content });
             })
            .catch((error) => { console.log('Error saving inventory: ' + error);  });

            this.$emit('submit', false);
        },
        loadContent(){
            this.servicePointId = this.$parent.servicePointId;
            this.axe.get('/getstockmanagerdata', { params: { request: { servicePointId: this.servicePointId }}})
                .then((response) => {
                    let data = response.data;
                    /** update arrays instead of assigning new ones, they are already binded to vue */
                    this.collectionResourcesWastes.selected.splice(0, 0, ...data.collectionResourcesWastes.selected);
                    this.collectionResourcesWastes.unselected.splice(0, 0, ...data.collectionResourcesWastes.unselected);
                    this.pieceCollectionResourcesWastes.selected.splice(0, 0, ...data.pieceCollectionResourcesWastes.selected);
                    this.pieceCollectionResourcesWastes.unselected.splice(0, 0, ...data.pieceCollectionResourcesWastes.unselected);
                    this.collectionResourcesStock.splice(0, 0, ...data.collectionResourcesStock);
                    this.pieceCollectionResourcesStock.splice(0, 0, ...data.pieceCollectionResourcesStock);
                    this.permissions.canEdit = data.permissions.canEdit;
                    this.sentences = data.sentences;
                })
                .catch((error) => { 
                    console.log('Error retrieving tab content : ' + error); 
                })
                .then(() => {
                    this.loading = false;
                });
        }
    },
    mounted(){

    },
    created() {
        this.loadContent();
    }
});